<section class="main-content">
  @if (responseAvailability) {
    <div class="row">
      <div class="col-lg-6 col-sm-12 col-md-12 col-xs-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div class="title-flex">
                  <h4 class="main-title">
                    <span tuiAvatar="@tui.credit-card"  class="taga-icons"></span>
                    <span class="mt-1 pad-left-10">Job Confirmation</span>
                  </h4>
                </div>
                <hr class="title-line mt-1">
              </div>
            </div>
            @if (responseAvailability.isSMSConfirmed || isSuccess) {
              <div class="row mt-3">
                <div class="col-12">
                  <div class="alert alert-outline mt-2" role="alert">
                    <div class="success-color">
                      Job Confirmation has been done!
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (!responseAvailability.isSMSConfirmed && !responseAvailability.isActive) {
              <div class="row mt-3"
                >
                <div class="col-12">
                  <div class="alert alert-outline mt-2" role="alert">
                    <div class="warning-color">
                      {{responseAvailability.message}}
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="row mt-3">
              <div class="col-12">
                <table class="table table-sm table-bordered">
                  <tbody>
                    <tr>
                      <td class="font-bold">
                        Labor Name
                      </td>
                      <td>
                        {{responseAvailability.laborName}}
                      </td>
                    </tr>
                    <!-- <tr>
                    <td class="font-bold">
                      SO#
                    </td>
                    <td>
                      {{responseAvailability.serviceOrderFullNumber}}
                    </td>
                  </tr> -->
                  <tr>
                    <td class="font-bold">
                      Booth#
                    </td>
                    <td>
                      {{responseAvailability.boothNumber}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      Show Name
                    </td>
                    <td>
                      {{responseAvailability.showName}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      City
                    </td>
                    <td>
                      {{responseAvailability.showCity}}, {{responseAvailability.showState}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      Venue
                    </td>
                    <td>
                      {{responseAvailability.venueName}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      Job Date
                    </td>
                    <td>
                      {{responseAvailability.jobDate |date:DAY_NAME_MONTH_DAY_YEAR}}
                    </td>
                  </tr>
                  <tr>
                    <td class="font-bold">
                      Job Time
                    </td>
                    <td>
                      <!-- Feedback #23: start time only. The end time was being read as a
                           guaranteed finish, so it is no longer shown on the confirmation. -->
                      {{responseAvailability.jobStartTimeDisplay}}
                    </td>
                  </tr>
                  <!-- Feedback #23: the "Login Url" row is removed — Leadmen sign in through the
                       downloaded app, so a web login link on the confirmation is misleading.
                       The browser version of the LeadMan app is retired, so the API no longer
                       returns a login URL at all. -->
                </tbody>
              </table>
            </div>
            @if (!isSuccess && responseAvailability.success) {
              <div class="col-12 text-center">
                <h6 class="text-center warning-color">
                  <strong>Are you available?</strong>
                </h6>
                <div class="mt-3">
                  <button type="button" class="btn btn-success" (click)="confirmAvailability(true)">
                    <i class="fas fa-check pad-right-10"></i>Yes
                  </button>
                  <button type="button" class="btn btn-warning margin-left-10 " (click)="confirmAvailability(false)">
                    <i class="fas fa-times pad-right-10"></i>No
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
</section>
